import type { CompoundEntityRef } from '@backstage/catalog-model';

import { stringifyEntityRef } from '@backstage/catalog-model';
import { useApi } from '@backstage/frontend-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { createCompoundEntityRef } from '@ipen-portal/plugin-common';
import { useCallback } from 'react';

import { useCacheCallback } from './useCacheCallback';

export type GetEntityByRefCallback = ReturnType<
  typeof useGetEntityByRefCallback
>;

export const useGetEntityByRefCallback = () => {
  const catalogApi = useApi(catalogApiRef);
  const requestCallback = useCallback(
    async (
      entityRef: CompoundEntityRef | null | string | undefined,
      options?: {
        fallbackKind?: string;
      },
    ) => {
      const ref = createCompoundEntityRef(entityRef, options?.fallbackKind);
      if (!ref) return null;
      return await catalogApi.getEntityByRef(ref);
    },
    [catalogApi],
  );
  return useCacheCallback(
    requestCallback,
    {
      getCacheKey: (entityRef, options) => {
        const ref = createCompoundEntityRef(entityRef, options?.fallbackKind);
        if (!ref) {
          return 'entityRef:null';
        }
        return `useGetEntityByRefCallback:${stringifyEntityRef(ref)}`;
      },
    },
    [requestCallback],
  );
};
